export default function genererOtPatrimoine() {
  return {
    dispositifTechnique: {
      autreEquipementNecessaire: null,
      cableEdfProx: null,
      couleurRAL: null,
      declarationPrealable: null,
      distanceEnMCablesEdf: null,
      echelleNecessaire: null,
      eclairable: null,
      fournisseurElectricite: null,
      fournisseurElectriciteId: null,
      grueNecessaire: null,
      hauteurSousPanneau: null,
      largeurToit: null,
      longueur: null,
      nacelleNecessaire: null,
      obstacle: null,
      particularite: null,
      planRecollement: null,
      publicitaire: null,
      restrictionsAffichage: null,
      tiersProprietaire: null,
      tiersProprietaireId: null,
      valeurAcquisition: null,
    },
    emplacementTechnique: {
      acces: null,
      accesSiteSurRdv: null,
      codeBarre: null,
      degreDeniveleTerrain: null,
      natureSol: null,
      groupeDhabitation: null,
      numUG: null,
      quartier: null,
    },
    materielTechnique: {
      passerelle: null,
      typeEclairage: null,
      longueur: null,
      largeur: null,
    },
    otPatrimoineAccessoires: [],
    emplacementId: null,
    materielId: null,
    dispositifId: null,
    faceId: null,
    face: null,
    materiel: null,
    emplacement: null,
    dispositif: null,
    nomenclature: null,
    nomenclatureTypeId: null,
  };
}
